<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M15 7.41L10.6698 12L15 16.59L13.6604 18L8 12L13.6604 6L15 7.41Z" fill="currentColor" />
  </svg>
</template>
